// Arbitrum token and bridge addresses used across the SDK and API layer.
// Single source of truth — import from here, never redeclare locally.

export const USDC_ARBITRUM = '0xaf88d065e77c8cC2239327C5EDb3A432268e5831' as const;
export const HL_BRIDGE_ARBITRUM = '0x2Df1c51E09aECF9cacB7bc98cB1742757f163dF7' as const;
export const ARBITRUM_CHAIN_ID = 42161 as const;
